<template>
  <app-panel title="Заполнение ГЦЖС">
    <div :class="$style.container">
      <div class="mb-4">
        <elsa-v-upload v-model="file" />
      </div>
      <app-button @click="onUpload" color="success" type="border">Отправить</app-button>
    </div>
  </app-panel>
</template>

<script>
import notifyHttpError from "@/mixins/notifyHttpError";

export default {
  name:    "GCJS",
  mixins:  [notifyHttpError],
  data() {
    return {
      file:      null,
      fileError: false,
    };
  },
  methods: {
    onUpload() {
      if (this.file === null) return this.$vs.notify({
        color: 'danger',
        title: "Файл не выбран",
      });

      this.$vs.loading({ type: 'default' });

      const body = new FormData();
      body.append('buildings_id', this.$store.getters['appUser/selectedHouse'].id);
      body.append('file', this.file);
      body.append('month', this.$options.filters.formatDate(this.month));
      body.append('le_id', this.$store.getters['appUser/selectedHouse'].legal_entities_id);

      const fileName = this.file.name
      this.$http.post('fillform/fill_privileges_xml', body).then(( response ) => {
        const { data } = response;
        const blob = new Blob([data], { type: 'text/xml' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        link.remove();
      }, this.notifyHttpError).finally(() => {
        this.file = null;
        this.$vs.loading.close();
      });
    },
  },
};
</script>

<style lang="scss" module>
.container {
  max-width: 220px;
  margin: 0 auto;
  text-align: center;
}
</style>
